import { initData } from "@telegram-apps/sdk-react"
import en from "./locales/en.json"
import ru from "./locales/ru.json"
import i18n from "i18next"
import { initReactI18next } from "react-i18next"

const userData = initData.user()

i18n.use(initReactI18next).init({
  lng: userData?.language_code,
  resources: { en: { ...en }, ru: { ...ru } },
  fallbackLng: "en",
})
